<div class="flex flex-col gap-16 p-5">
  <!-- Sección de la cabecera. -->
  <section class="w-full flex flex-col items-center gap-5">
    <div class="text-2xl font-medium text-center">Editar un host</div>
  </section>

  <!-- Sección del cuerpo. -->
  <section>
    <!-- Formulario. -->
    <form class="flex flex-col" [formGroup]="form" (ngSubmit)="update()">
      <mat-form-field>
        <mat-label>ID</mat-label>
        <input type="number" name="id" formControlName="id" matInput readonly />
      </mat-form-field>

      <div class="flex gap-5 items-center">
        <mat-form-field class="grow">
          <mat-label>Tipo</mat-label>
          <input
            type="text"
            name="type"
            placeholder="Ex. C"
            maxlength="1"
            formControlName="type"
            matInput
          />
        </mat-form-field>
        <mat-hint align="end">
          {{ formType?.value ? formType?.value.length : 0 }} / 1
        </mat-hint>
      </div>

      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input type="text" name="name" formControlName="name" matInput />
      </mat-form-field>

      <mat-slide-toggle formControlName="status" class="mt-5">
        <span class="text-base pl-2">{{
          formStatus?.value ? "Activo" : "Deshabilitado"
        }}</span>
      </mat-slide-toggle>

      <!-- Errores. -->
      @if (errors) {
      <div class="flex flex-col gap-2 text-center mt-10">
        @for (error of errors; track error) {
        <span class="text-sm text-red-500">{{ error }}</span>
        }
      </div>
      }

      <!-- Botón de acción. -->
      <button
        type="submit"
        mat-flat-button
        class="mt-10"
        [disabled]="form.invalid || loading"
      >
        @if (loading) {
        <mat-spinner diameter="18"></mat-spinner>
        } @else {
        <span class="text-base">Editar</span>
        }
      </button>
    </form>
  </section>
</div>
